/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import { DataGridCustom, Input, Grid, Button, SelecaoMultipla, RadioComLabel } from '../../components';
import {
  opcaoFiltroTipoParticipacao,
  tiposEstado,
  tipoRegime,
} from '../../utils/listsSelect';
import { doGet } from '../../utils/requests';
import SelecaoEntidade from './SelecaoEntidade';
import SelecaoSuperintendencia from './SelecaoSuperintendencia';
import { ehPapelObservadorRelatorio } from '../../utils/helpers';

const participanteRGPS = '01000';

class FiltroRelatorioAnalitico extends Component {
  constructor() {
    super();
    this.filtroRelatorioAnalitico = JSON.parse(sessionStorage.getItem('filtroRelatorioAnalitico'));
    this.state = {
      tipoRegime: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.tipoRegime ?
        this.filtroRelatorioAnalitico.tipoRegime : null,
      tipoRegimeObservador: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.tipoRegimeObservador ?
        this.filtroRelatorioAnalitico.tipoRegimeObservador : null,
      tipoEntidade: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.tipoEntidade ?
        this.filtroRelatorioAnalitico.tipoEntidade : null,
      tipoEntidadeObservador: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.tipoEntidadeObservador ?
        this.filtroRelatorioAnalitico.tipoEntidadeObservador : null,
      uf: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.uf ?
        this.filtroRelatorioAnalitico.uf : null,
      uFObservador: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.uFObservador ?
        this.filtroRelatorioAnalitico.uFObservador : null,
      participante: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.participante ?
        this.filtroRelatorioAnalitico.participante : null,
      participanteObservador: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.participanteObservador ?
        this.filtroRelatorioAnalitico.participanteObservador : null,
      superintendencia: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.superintendencia ?
        this.filtroRelatorioAnalitico.superintendencia : null,
      gex: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.gex ?
        this.filtroRelatorioAnalitico.gex : null,
      aps: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.aps ?
        this.filtroRelatorioAnalitico.aps : null,
      visao: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.visao ?
        this.filtroRelatorioAnalitico.visao : null,
      opcao: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.opcao ?
        this.filtroRelatorioAnalitico.opcao : null,
      estado: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.estado ?
        this.filtroRelatorioAnalitico.estado : null,
      consultaPorVisao: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.consultaPorVisao ?
        this.filtroRelatorioAnalitico.consultaPorVisao : null,
      configComponenteSelecaoMultipla: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.configComponenteSelecaoMultipla ?
        this.filtroRelatorioAnalitico.configComponenteSelecaoMultipla : null,
      lista: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.lista ?
        this.filtroRelatorioAnalitico.lista : [],
      valorComboSelecaoMultipla: this.filtroRelatorioAnalitico && this.filtroRelatorioAnalitico.valorComboSelecaoMultipla ?
        this.filtroRelatorioAnalitico.valorComboSelecaoMultipla : null,
      listaSuperintendencias: [],
      listaGexs: [],
      listaAps: [],
      listaEntes: [],
      listaTiposRegimes: [],
      listaTiposRegimesOutrosPapeis: [],
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem('filtroRelatorioAnalitico')) {
      this.handleSearch();
    }
    this.carregaUnidadesOrganicas(24, null, this.carregaSuperintendencias);
    this.carregarListaTiposRegimes();
  }

  configurarSelecaoMultipla = (estado) => {
    let configuracao;
    switch (estado) {
      case '2':
        configuracao = {
          // listaSource: this.props.exigencias,
          labelCombobox: "Exigência",
          titulo: "Tipos de exigência",
          exibirBotaoIncluir: true,
          exibirTabelaItens: true,
          retirarLinhaSeparadora: false,
          exibirComboBox: true,
        }
        break;
      case '9':
        configuracao = {
          // listaSource: this.props.motivosIndeferimento,
          labelCombobox: "Motivo de indeferimento",
          titulo: "Tipos de indeferimento",
          exibirBotaoIncluir: true,
          exibirTabelaItens: true,
          retirarLinhaSeparadora: false,
          exibirComboBox: true,
        }
        break;
      case '10':
        configuracao = {
          // listaSource: this.props.motivosSuspensao,
          labelCombobox: "Motivo de suspensão",
          titulo: "Tipos de suspensão",
          exibirBotaoIncluir: false,
          exibirTabelaItens: false,
          retirarLinhaSeparadora: false,
          exibirComboBox: true,
        }
        break;
        case '12':
          configuracao = {
            // listaSource: this.props.motivosCessacao,
            labelCombobox: "Motivo de cessação",
            titulo: "Tipos de cessação",
            exibirBotaoIncluir: false,
            exibirTabelaItens: false,
            retirarLinhaSeparadora: false,
            exibirComboBox: true,
          }
          break;
      default:
        configuracao = {
          // listaSource: [],
          labelCombobox: "",
          titulo: "",
          exibirBotaoIncluir: false,
          exibirTabelaItens: false,
          retirarLinhaSeparadora: true,
          exibirComboBox: false,
        }  
          break;
        }
        return configuracao;
  }

  filtrarRegimes = () => {
    let retorno = this.state.listaTiposRegimes;
    if (this.props.papelUsuarioLogado === 'analista-rgps' ||
    (this.state.tipoRegimeObservador === 1 && ehPapelObservadorRelatorio(this.props.papelUsuarioLogado))) {
      retorno = this.state.listaTiposRegimes.filter(item => (item.label !== 'RGPS'));
    }
    if (this.props.papelUsuarioLogado !== 'analista-rgps' ||
    (this.state.tipoRegimeObservador === 2 && ehPapelObservadorRelatorio(this.props.papelUsuarioLogado))) {
      retorno = tipoRegime;
    } 
    this.setState({ listaTiposRegimes: retorno});
  }

  handleChangeOpcao = (value) => {
    this.filtrarRegimes();
    let ehVisao = false;
    if ([2, 3].includes(value)) {
      ehVisao = true;
    } else {
      ehVisao = false;
    }

    this.setState(
      { 
        opcao: value,
        consultaPorVisao: ehVisao,
      }, () => this.limparFormulario(value)
    );
  }

  handleChange = (changeObj, name, callback = null) => {
    let configuracao = this.state.configComponenteSelecaoMultipla;
    let limparCampos = false;

    if (name === 'estado') {
      configuracao = this.configurarSelecaoMultipla(changeObj.value);
      this.setState({lista: []});
    }

    if (name === 'tipoRegimeObservador') {
      if (changeObj.value === 1) {
        this.setState({participanteObservador: participanteRGPS});
      }
      this.setState({tipoRegimeObservador: changeObj.value}, this.filtrarRegimes);
      // if (this.state.tipoRegimeObservador !== null && (this.state.tipoRegimeObservador !== changeObj.value)) {
      //   limparCampos = true;
      // }
    }

    if (name === 'tipoRegime') {
      if (changeObj.value === 1) {
        this.setState({participante: participanteRGPS});
      }
      // if (this.state.tipoRegime !== null && (this.state.tipoRegime !== changeObj.value)) {
      //   limparCampos = true;
      // }
    }

    if (name === 'estado') {
      if (this.state.valorComboSelecaoMultipla !== null && (this.state.valorComboSelecaoMultipla !== changeObj.value)) {
        limparCampos = true;
      }
    }

    if(callback === null) {
      callback = () => this.trataFormulario(limparCampos, name);
    }

    this.setState({
      [name]: changeObj.value,
      configComponenteSelecaoMultipla: configuracao,
    }, callback,
    );
  }

  handleChangeRadio = (changeObj, name) => {
    this.setState({ [name]: changeObj.value, consultaPorVisao: true });
  };

  trataFormulario = (limparCampos, campoAlterado) => {
    if (campoAlterado === 'tipoRegimeObservador' && limparCampos) {
      this.setState({ 
        tipoEntidadeObservador: null,
        uFObservador: null,
        participanteObservador: null,
        opcao: null,
        participante: null,
        tipoEntidade: null,
        uf: null,
      });
    }
    if (campoAlterado === 'tipoRegime' && limparCampos) {
      this.setState({ tipoEntidade: null, uF: null, participante: null });
    }

    if (campoAlterado === 'estado' && limparCampos) {
      this.setState({ valorComboSelecaoMultipla: null });
    }

    if (campoAlterado === 'tipoEntidade') {
      this.setState({ participante: null, uf: null });
    }
    if (campoAlterado === 'uf') {
      this.setState({ participante: null });
    }
    if (campoAlterado === 'superintendencia') {
      this.setState({ gex: null, aps: null, ente: null });
      if (this.state.superintendencia) {
        this.carregaUnidadesOrganicas(3, this.state.superintendencia, this.carregaGexs);
      }
    }
    if (campoAlterado === 'gex') {
      this.setState({ aps: null, ente: null });
      if (this.state.gex) {
        this.carregaUnidadesOrganicas(4, this.state.gex, this.carregaAps);
      }
    }
    this.props.observardorDeMudanca();
  }

  limparFormulario = (valor) => {
    if (valor === '' || ((valor === 2 || valor === 3) && this.state.tipoEntidade !== null)) {
      this.setState({ tipoEntidade: null });
    }
    if (((valor === 2 || valor === 3) && this.state.participante !== null)) {
      this.setState({ participante: null });
    }
    if (this.state.tipoRegime !== null) {
      this.setState({ tipoRegime: null });
    }
    if (this.state.superintendencia !== null) {
      this.setState({ superintendencia: null });
    }
    if (this.state.gex !== null) {
      this.setState({ gex: null });
    }
    if (this.state.visao !== null) {
      this.setState({ visao: null });
    }

    this.props.observardorDeMudanca();
  }

  addMessage = (text) => {
    const message = {
      title: 'Titulo',
      text,
      timeout: 5000,
      type: 'danger',
    };
    window.DtpSnackbar.addMessage(message);
  };

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.addMessage('Nenhum resultado encontrado para o filtro informado.');
        } else {
          this.addMessage(`${data.mensagem}`);
        }
      } else {
        this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');
      }
    }
  };

  carregarListaTiposRegimes = () => {
    this.setState({ listaTiposRegimes: tipoRegime });
  }

  carregaUnidadesOrganicas = (categoria, codigoSuperior, sucesso) => {
    const parametros = {};
    if (codigoSuperior) {
      parametros.codigoSuperior = codigoSuperior;
    }
    if (categoria) {
      parametros.categoria = categoria;
    }
    doGet('unidades-organicas', sucesso, this.tratarErro, parametros);
  }

  carregaSuperintendencias = (response) => {
    const superintendencias = [];
    response.data.forEach((item) => {
      superintendencias.push({
        label: item.nomeUnidade,
        value: item.codigoUnidade,
      });
    });
    this.setState({ listaSuperintendencias: superintendencias });
  }

  carregaGexs = (response) => {
    const gexs = [];
    response.data.forEach((item) => {
      gexs.push({
        label: item.nomeUnidade,
        value: item.codigoUnidade,
      });
    });
    this.setState({ listaGexs: gexs });
  }

  carregaAps = (response) => {
    const aps = [];
    response.data.forEach((item) => {
      aps.push({
        label: item.nomeUnidade,
        value: item.codigoUnidade,
      });
    });
    this.setState({ listaAps: aps });
  }

  carregaEntesFederativos = (aps) => {
    const parametros = { aps };
    doGet('entes-federativos', this.tratarSucessoEntesFederativos, this.tratarErro, parametros);
  }

  tratarSucessoEntesFederativos = (response) => {
    const entes = [];
    response.data.forEach((item) => {
      entes.push({
        label: item.nomeRpps,
        value: item.idParticipante,
      });
    });
    this.setState({ listaEntes: entes });
  }

  validaNaoEhSuperintendenciaESelecionouAmbos = () => {
    const opcaoAmbos = 1;
    return (!this.state.superintendencia && this.state.opcao === opcaoAmbos);
  }

  validaEhPapelObservador = () => {
    return ehPapelObservadorRelatorio(this.props.papelUsuarioLogado) && !this.state.tipoRegimeObservador;
  }

  validaEhPapelObservadorERegimeSelecionado = () => {
    return ((this.props.papelUsuarioLogado === 'analista-rgps') && this.state.opcao !== 1) ||
    (ehPapelObservadorRelatorio(this.props.papelUsuarioLogado) && this.state.tipoRegimeObservador === 1 && this.state.opcao !== 1);
  }

  verificarTextoHintBotaoInclusao = () => {
    let retorno = 'item';
    switch (this.state.estado) {
      case '2':
        retorno = 'exigência';
        break;
      case '9':
        retorno = 'motivo';
        break;
      case '10':
        retorno = 'motivo';
        break;
      default:
        break;
    }
    return retorno;
  }

  montaFiltrosDefault = () => (
    <React.Fragment>
      {ehPapelObservadorRelatorio(this.props.papelUsuarioLogado) ?
        <SelecaoEntidade
          handleChange={this.handleChange}
          destinatarios={this.props.destinatarios}
          papelUsuarioLogado={this.props.papelUsuarioLogado}
          titulo="Visualizar como"
          retirarLinhaSeparadora={false}
          tipoRegime={this.state.tipoRegimeObservador}
          tipoEntidade={this.state.tipoEntidadeObservador}
          uf={this.state.uFObservador}
          participante={this.state.participanteObservador}
          nomeAtributoComboboxRegime="tipoRegimeObservador"
          nomeAtributoComboboxParticipante="participanteObservador"
          nomeAtributoComboboxTipoEntidade="tipoEntidadeObservador"
          nomeAtributoComboboxUF="uFObservador"
          listaTiposRegimes={tipoRegime}
          labelComboboxParticipante="Participante Observador"
        />
      : '' }
      <DataGridCustom title="Filtro básico">
        <div className="row">
          <Grid cols="12 12 12 12">
            <RadioComLabel
              value={this.state.opcao}
              name="opcao"
              itemList={opcaoFiltroTipoParticipacao}
              onChange={value => this.handleChangeOpcao(value)}
              animate={false}
              label="Opção"
              disabled={this.validaEhPapelObservador()}
              disposicao='horizontal'
              required
            />
          </Grid>
        </div>
        {this.validaNaoEhSuperintendenciaESelecionouAmbos() ? (
          <SelecaoEntidade
            handleChange={this.handleChange}
            destinatarios={this.props.destinatarios}
            papelUsuarioLogado={this.props.papelUsuarioLogado}
            titulo=""
            retirarLinhaSeparadora={true}
            tipoRegime={this.state.tipoRegime}
            tipoEntidade={this.state.tipoEntidade}
            uf={this.state.uf}
            participante={this.state.participante}
            nomeAtributoComboboxRegime="tipoRegime"
            nomeAtributoComboboxParticipante="participante"
            nomeAtributoComboboxTipoEntidade="tipoEntidade"
            nomeAtributoComboboxUF="uf"
            listaTiposRegimes={this.state.listaTiposRegimes}
            labelComboboxParticipante="Participante"
          />
        ) : ''}
        {this.validaEhPapelObservadorERegimeSelecionado() ? (
          <SelecaoSuperintendencia
            handleChange={this.handleChange}
            tipoRegime={this.state.tipoRegime}
            papelUsuarioLogado={this.props.papelUsuarioLogado}
            listaSuperintendencias={this.state.listaSuperintendencias}
            listaGexs={this.state.listaGexs}
            listaAps={this.state.listaAps}
            superintendencia={this.state.superintendencia}
            gex={this.state.gex}
            aps={this.state.aps}
            tipoRegimeObservador={this.state.tipoRegimeObservador}
            titulo=""
            retirarLinhaSeparadora={true}
          />
        ) : ''}
      </DataGridCustom>
      <DataGridCustom title="Estado do requerimento">
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              label="Estado"
              name="estado"
              onChange={e => this.handleChange(e, 'estado')}
              itemList={tiposEstado}
              value={this.state.estado}
              validationState="active"
              custom
              placeholder="Selecione uma opção para filtrar"
              disabled={this.validaEhPapelObservador()}
              required
            />
          </Grid>
        </div>
      </DataGridCustom>
      <SelecaoMultipla
        handleChange={this.handleChange}
        configuracao={this.state.configComponenteSelecaoMultipla}
        estado={this.state.estado}
        hint={this.verificarTextoHintBotaoInclusao()}
        listaEstadosComSelecaoMultipla={[2,9,10]}
        lista={this.state.lista}
        // ehPapelObservadorRelatorio={ehPapelObservadorRelatorio(this.props.papelUsuarioLogado)}
        valorComboSelecaoMultipla={this.state.valorComboSelecaoMultipla}
        observardorDeMudanca={this.props.observardorDeMudanca}
      />
    </React.Fragment>
  )

  handleSearch = () => {
    const participanteObservadorSelecionado = this.state.participanteObservador;
    const regimeSelecionado = this.state.tipoRegime;
    const entidadeSelecionada = this.state.tipoEntidade;
    const ufSelecionada = this.state.uf;
    const participanteSelecionado = this.state.participante;
    const estadoSelecionado = this.state.estado;
    const opcaoSelecionada = this.state.opcao;
    const superintendenciaSelecionada = this.state.superintendencia;

    if (ehPapelObservadorRelatorio(this.props.papelUsuarioLogado) && !participanteObservadorSelecionado) {
      this.addMessage('Selecione o participante Observador.');
      return;
    }

    if (!opcaoSelecionada) {
      this.addMessage('Selecione uma opção.');
      return;
    }
    // refatorar essa parte
    if (this.props.papelUsuarioLogado === 'analista-rgps' || participanteObservadorSelecionado === '01000') {
      if (opcaoSelecionada && opcaoSelecionada === 1) {
        if (!regimeSelecionado) {
          this.addMessage('Selecione um regime.');
          return;
        }
        if (regimeSelecionado !== 1 && !entidadeSelecionada) {
          this.addMessage('Selecione uma entidade.');
          return;
        }
        if ((entidadeSelecionada && entidadeSelecionada === 2) && ufSelecionada === null) {
          this.addMessage('Selecione uma UF.');
          return;
        }
        if (!participanteSelecionado) {
          this.addMessage('Selecione um participante.');
          return;
        }
      } else if ((opcaoSelecionada && opcaoSelecionada !== 1)) {
        if (!superintendenciaSelecionada) {
          this.addMessage('Selecione uma superintendência.');
          return;
        }
      }
    } else {
      if (opcaoSelecionada && opcaoSelecionada === 1) {
        if (!regimeSelecionado) {
          this.addMessage('Selecione um regime.');
          return;
        }
        if (regimeSelecionado !== 1 && !entidadeSelecionada) {
          this.addMessage('Selecione uma entidade.');
          return;
        }
        if ((entidadeSelecionada && entidadeSelecionada === 2) && ufSelecionada === null) {
          this.addMessage('Selecione uma UF.');
          return;
        }
        if (!participanteSelecionado) {
          this.addMessage('Selecione um participante.');
          return;
        }
      }
    }

    if (!estadoSelecionado) {
      this.addMessage('Selecione um estado.');
      return;
    }

    this.props.handleSearchFilter(this.state);

  }

  handleSearchButton = () => {
    let filtroRelatorioAnalitico = {
      tipoRegime: this.state.tipoRegime,
      tipoRegimeObservador: this.state.tipoRegimeObservador,
      tipoEntidade: this.state.tipoEntidade,
      tipoEntidadeObservador: this.state.tipoEntidadeObservador,
      uf: this.state.uf,
      uFObservador: this.state.uFObservador,
      participante: this.state.participante,
      participanteObservador: this.state.participanteObservador,
      superintendencia: this.state.superintendencia,
      gex: this.state.gex,
      aps: this.state.aps,
      visao: this.state.visao,
      opcao: this.state.opcao,
      estado: this.state.estado,
      consultaPorVisao: this.state.consultaPorVisao,
      lista: this.state.lista,
      configComponenteSelecaoMultipla: this.state.configComponenteSelecaoMultipla,
      valorComboSelecaoMultipla: this.state.valorComboSelecaoMultipla,
    };

    filtroRelatorioAnalitico = JSON.stringify(filtroRelatorioAnalitico);
    sessionStorage.setItem('filtroRelatorioAnalitico', filtroRelatorioAnalitico);

    this.handleSearch();
  }

  render() {
    const filtrosPesquisa = this.montaFiltrosDefault();

    if (!filtrosPesquisa) {
      return null;
    }

    return (
      <DtpAccordionGroup>
        <DtpAccordionPanel
          headingId="relatorio"
          panelId="filtro-relatorio"
          icon="ico-filter"
          title={`${this.props.tipo}`}
        >
          {filtrosPesquisa}
          <div className="row">
            <Button
              className="dtp-primary right"
              title="Pesquisar"
              onClick={() => this.handleSearchButton()}
              hint="Pesquisar de acordo com o filtro aplicado"
            />
          </div>
        </DtpAccordionPanel>
      </DtpAccordionGroup>
    );
  }
}

FiltroRelatorioAnalitico.propTypes = {
  handleSearchFilter: PropTypes.func,
  observardorDeMudanca: PropTypes.func,
  papelUsuarioLogado: PropTypes.string,
}.isRequired;

export default FiltroRelatorioAnalitico;



// WEBPACK FOOTER //
// ./src/pages/relatorios/FiltroRelatorioAnalitico.jsx